import $ from 'jquery';
window.$ = window.jQuery = $;
window.$ = window.jQuery = $.noConflict();

export class SmoothAnchor {
    constructor() {
        document.addEventListener('DOMContentLoaded', () => {
            $('[data-anchor^="#"]').click(function (e) {
                e.preventDefault();
                if (!$(this).hasClass('active')) {
                    $('[data-anchor^="#"]').removeClass('active');
                }
                $(this).addClass('active');
                $('html, body').animate({
                    scrollTop: $($(this).data('anchor')).offset().top
                }, 700);
            });
        })
    }
}